import React, { useCallback, useEffect, useState } from "react";
import api, { errMsg } from "../../core/api";
import { useApp } from "../../core/AppContext";
import { fa, formatDate } from "../../core/format";
import ResponsiveList from "../../components/ResponsiveList";
import LeaveFlowModal from "../records/LeaveFlow";
import { DecisionModal } from "./LeaveApprovals";

export default function ManagerInbox() {
  const { toast } = useApp();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dec, setDec] = useState(null);
  const [flowId, setFlowId] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try { setRows((await api.get("/manager-inbox")).data.items); } catch (e) { toast(errMsg(e), "err"); } finally { setLoading(false); }
  }, [toast]);
  useEffect(() => { load(); }, [load]);

  const done = (d) => {
    setDec(null);
    toast(d.stage === "approved" ? "تأیید نهایی شد" : "درخواست رد شد");
    load(); // آیتم از این فهرست حذف می‌شود و در بخش خودش (تأیید مرخصی/درخواست‌ها) دیده می‌شود
  };

  return (
    <>
      <div className="page-head"><div><h2>منتظر تأیید مدیر بندر</h2><p>همه‌ی درخواست‌ها و تأییدیه‌هایی که برای شما ارسال شده است ({fa(rows.length)} مورد)</p></div></div>
      <ResponsiveList loading={loading} rows={rows} empty="مورد در انتظاری وجود ندارد"
        columns={[
          { key: "typeLabel", label: "نوع", render: (r) => <span className="badge wait">{r.typeLabel}</span> },
          { key: "requesterName", label: "درخواست‌دهنده", render: (r) => <b>{r.requesterName}</b> },
          { key: "title", label: "عنوان" },
          { key: "range", label: "بازه", render: (r) => `${formatDate(r.fromDate)} تا ${formatDate(r.toDate)}` },
          { key: "substituteName", label: "جانشین" },
        ]}
        mobileTitle={(r) => r.requesterName}
        mobileBadge={(r) => <span className="badge wait">{r.typeLabel}</span>}
        mobileMeta={(r) => [
          { icon: "fa-regular fa-file-lines", label: "عنوان", value: r.title },
          { icon: "fa-regular fa-calendar", label: "بازه", value: `${formatDate(r.fromDate)} تا ${formatDate(r.toDate)}` },
        ]}
        actions={(r) => (
          <>
            <button className="icon-btn" title="مراحل و جزئیات" onClick={() => setFlowId(r.id)}><i className="fa-solid fa-list-check" /></button>
            <button className="btn btn-sm" onClick={() => setDec({ item: r, approve: true })}><i className="fa-solid fa-check" /> تأیید</button>
            <button className="btn btn-sm btn-danger" onClick={() => setDec({ item: r, approve: false })}><i className="fa-solid fa-xmark" /> رد</button>
          </>
        )} />
      {dec && <DecisionModal item={dec.item} approve={dec.approve} onClose={() => setDec(null)} onDone={done} />}
      {flowId && <LeaveFlowModal id={flowId} onClose={() => setFlowId(null)} />}
    </>
  );
}